<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="商户编号"
                ><a-input v-model="queryParam.merchantNo" placeholder="商户编号"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="商户名称"
                ><a-input
                  v-model="queryParam.merchantName"
                  placeholder="商户名称"
              /></a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="商户类型">
                  <a-select
                    v-model="queryParam.merchantType"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="1">公司</a-select-option>
                    <a-select-option value="2">个人</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="状态">
                  <a-select
                    v-model="queryParam.sta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="I">正常</a-select-option>
                    <a-select-option value="X">停用</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="认证状态">
                  <a-select
                    v-model="queryParam.authSta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="I">已认证</a-select-option>
                    <a-select-option value="R">未认证</a-select-option>
                    <a-select-option value="A">审核中</a-select-option>
                    <a-select-option value="X">认证失败</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否开通签约">
                  <a-select
                    v-model="queryParam.isOpen"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="T">已开通</a-select-option>
                    <a-select-option value="F">未开通</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button
                  class="button-margin-left"
                  @click="() => (queryParam = {})"
                  >重置</a-button
                >
                <!-- <a-button
                  type="primary"
                  icon="plus"
                  @click="add"
                  v-hasAnyPermission="`information:add`"
                  class="button-margin-left"
                  >新建</a-button
                > -->
                <a @click="toggleAdvanced" class="button-margin-left">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        rowKey="id"
        :scroll="{ x: 2000 }"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
      >
        <span slot="tagItem" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag
              class="render-tag"
              :color="record.merchantType == '1' ? '#108ee9' : '#87d068'"
              >{{ record.merchantType == "1" ? "公司" : "个人" }}</a-tag
            >

            <a-tag
              class="render-tag"
              :color="record.sta == 'I' ? '#FF5722' : 'grey'"
              >{{ record.sta == "I" ? "有效" : "停用" }}</a-tag
            >

            <a-tag
              class="render-tag"
              :color="record.isShow == 'F' ? '#108ee9' : 'red'"
              >{{ record.isShow == "F" ? "外显" : "禁止外显" }}</a-tag
            >

            <a-tag
              class="render-tag"
              :color="record.authSta == 'I' ? '#5FB878' : 'grey'"
            >
              {{
                record.authSta == "I"
                  ? "已认证"
                  : record.authSta == "R"
                  ? "未认证"
                  : record.authSta == "A"
                  ? "审核中"
                  : "认证失败"
              }}
            </a-tag>

            <a-tag
              class="render-tag"
              :color="record.isOpen == 'T' ? '#009688' : 'grey'"
              >{{ record.isOpen == "T" ? "已开通签约" : "未开通签约" }}</a-tag
            >
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              @click="action(record, 'edit')"
              v-hasAnyPermission="`information:edit`"
              >编辑</a
            >
            <a
              class="a-action"
              @click="action(record, 'see')"
              v-hasAnyPermission="`information:see`"
              >查看</a
            >
            <a
              class="a-action"
              v-if="record.authSta == 'A'"
              @click="action(record, 'auth')"
              v-hasAnyPermission="`information:open`"
              >认证</a
            >
            <a
              class="a-action"
              @click="action(record, 'house')"
              v-hasAnyPermission="`information:house`"
              >房源</a
            >
            <a
              class="a-action"
              @click="action(record, 'link')"
              v-hasAnyPermission="`information:link`"
              >查看关联用户</a
            >

            <a-popconfirm
              :title="
                record.isShow == 'F' ? '确认禁止外显' : '确认启用外显' + `?`
              "
              @confirm="action(record, 'show')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`information:show`"
            >
              <a class="a-action">{{
                record.isShow == "F" ? "禁止外显" : "启用外显"
              }}</a>
            </a-popconfirm>

            <!-- <a-popconfirm
              title="确认解除关联?"
              @confirm="action(record, 'off_line')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`information:off_line`"
              ><a class="a-action">解除关联</a></a-popconfirm
            >-->

            <a-popconfirm
              :title="record.sta == 'I' ? '确认停用商户?' : '确认启用商户?'"
              @confirm="action(record, 'disable')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`information:disable`"
            >
              <a class="a-action">{{
                record.sta == "I" ? "停用商户" : "启用商户"
              }}</a>
            </a-popconfirm>
          </template>
        </span>
      </s-table>
    </a-card>

    <a-modal
      v-model="modal.visible"
      :title="modal.title"
      :footer="null"
      :width="700"
    >
      <div>
        <div class="box-column">
          <p style="width: 30%;">用户编号</p>
          <p>昵称</p>
          <p>性别</p>
          <p>手机号</p>
          <p>操作</p>
        </div>
        <div class="box-cell" v-for="(item, idx) in modal.bindList" :key="idx">
          <p style="width: 30%;">{{ item.userNo }}</p>
          <p>{{ item.nickName }}</p>
          <p>{{ item.sex }}</p>
          <p>{{ item.mobile }}</p>
          <p>
            <a-popconfirm
              title="确认解绑吗?"
              @confirm="unbind(item)"
              okText="确认"
              cancelText="取消"
              ><a class="a-action">解绑</a></a-popconfirm
            >
          </p>
        </div>
        <div v-if="modal.bindList.length == 0" style="text-align: center;">
          <a class="a-action" @click="showBindModal">绑定用户</a>
        </div>
      </div>
    </a-modal>

    <a-modal
      v-model="bindModal.visible"
      :title="bindModal.title"
      :footer="null"
      :width="1000"
    >
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号"
                ><a-input
                  v-model="bindModal.queryParam.mobile"
                  placeholder="手机号"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-button type="primary" @click="searchUser">查询</a-button>
              <a-button
                class="button-margin-left"
                @click="() => (bindModal.queryParam = {})"
                >重置</a-button
              >
            </a-col>
          </a-row>
        </a-form>
        <!-- 数据表格 -->
        <s-table
          ref="bindBable"
          size="default"
          rowKey="id"
          :columns="bindModal.columns"
          :data="bindModal.loadData"
          :isAuto="false"
          showPagination="auto"
        >
          <span slot="nickname" slot-scope="text, record">
            <template>
              <img
                :src="record.imageUrl"
                class="user-head"
                v-if="record.imageUrl"
              />
              {{ text }}
            </template>
          </span>
          <span slot="authsta" slot-scope="text"
            ><a-badge
              :status="text | statusTypeFilter"
              :text="text | statusFilter"
          /></span>
          <span slot="usertype" slot-scope="text">
            <a-tag :color="text == '1' ? '' : text == '2' ? '#2db7f5' : '#f50'">
              {{ text == "1" ? "普通用户" : text == "2" ? "管家" : "商户" }}
            </a-tag>
          </span>
          <span slot="action" slot-scope="text, record">
            <template>
              <a-popconfirm
                title="确认绑定吗?"
                @confirm="action(record, 'bind')"
                okText="确认"
                cancelText="取消"
                ><a class="a-action">绑定</a></a-popconfirm
              >
            </template>
          </span>
        </s-table>
      </div>
    </a-modal>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";

export default {
  name: "MerchantList",
  components: {
    STable,
    PageView
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      provinceList: [],
      cityList: [],
      tmpCityList: [],
      // 查询参数
      queryParam: {},
      modal: {
        visible: false,
        title: "绑定信息",
        bindList: []
      },
      bindModal: {
        visible: false,
        title: "绑定用户",
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: "用户昵称",
            dataIndex: "nickName",
            scopedSlots: { customRender: "nickname" }
          },
          {
            title: "性别",
            dataIndex: "sex"
          },
          {
            title: "手机号",
            dataIndex: "mobile"
          },
          {
            title: "邮箱",
            dataIndex: "email"
          },
          {
            title: "认证状态",
            dataIndex: "authSta",
            scopedSlots: { customRender: "authsta" }
          },
          {
            title: "用户类型",
            dataIndex: "userType",
            scopedSlots: { customRender: "usertype" }
          },
          // {
          //   title: "粉丝数",
          //   dataIndex: "fans"
          // },
          // {
          //   title: "更新时间",
          //   dataIndex: "modifyDatetime"
          // },
          {
            title: "操作",
            dataIndex: "action",
            align: "left",
            scopedSlots: { customRender: "action" }
          }
        ],
        //加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return this.$http.roomBksApi
            .pageUserBase(Object.assign(parameter, this.bindModal.queryParam))
            .then(res => {
              return res.resultObject;
            });
        }
      },
      currentMerchantNo: "",
      // 表头
      columns: [
        {
          title: "商户编号",
          dataIndex: "merchantNo",
          fixed: "left",
          width: 150
        },
        {
          title: "商户名称",
          dataIndex: "merchantName",
          scopedSlots: { customRender: "tagItem" },
          fixed: "left",
          width: 400
        },
        {
          title: "累计购买合同",
          dataIndex: "buyQuantity",
          width: 150
        },
        {
          title: "累计使用合同",
          dataIndex: "useQuantity",
          width: 150
        },
        {
          title: "地址",
          dataIndex: "address",
          ellipsis: true
        },
        {
          title: "商户介绍",
          dataIndex: "intro",
          ellipsis: true
        },
        {
          title: "创建时间",
          dataIndex: "createDatetime",
          ellipsis: true
        },
        {
          title: "操作人",
          dataIndex: "modifyUser"
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime",
          ellipsis: true
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          fixed: "right",
          width: 280,
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.roomBksApi
          .pageMerchantInfo(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  filters: {
    statusFilter(type) {
      let str = "已认证";
      if (type == "R") {
        str = "未认证";
      } else if (type == "X") {
        str = "认证失败";
      }
      return str;
    },
    statusTypeFilter(type) {
      let str = "success";
      if (type == "R") {
        str = "default";
      } else if (type == "X") {
        str = "error";
      }
      return str;
    }
  },
  created() {},
  methods: {
    /**
     * 操作
     * @param {Object} record
     * @param {Object} type
     */
    action(record, type) {
      if (type == "edit") {
        this.$router.push({
          name: "ModifyMerchantInfo",
          query: {
            merchantNo: record.merchantNo,
            param: this.queryParam
          }
        });
      } else if (type == "see" || type == "auth") {
        this.$router.push({
          name: "MerchantInfo",
          query: {
            merchantNo: record.merchantNo,
            isAuth: type == "see" ? false : true,
            param: this.queryParam
          }
        });
      } else if (type == "link") {
        this.modal.bindList.length = 0;
        this.modal.visible = true;
        this.currentMerchantNo = record.merchantNo;
        this.$http.roomBksApi
          .listMerchantBindUserByMerchantNo({ merchantNo: record.merchantNo })
          .then(res => {
            if (res && res.result == 0) {
              this.modal.bindList = res.resultObject;
            }
          });
      } else if (type == "show") {
        let flag = record.isShow;
        let param = {};
        param.merchantNo = record.merchantNo;
        param.isShow = flag == "F" ? "T" : "F";
        this.$http.roomBksApi.settingMerchantShow(param).then(res => {
          if (res && res.result == 0) {
            record.isShow = param.isShow;
            this.$message.success(res.msg);
          }
        });
      } else if (type == "disable") {
        let flag = record.sta;
        let param = {};
        param.merchantNo = record.merchantNo;
        param.sta = flag == "I" ? "X" : "I";
        this.$http.roomBksApi.settingMerchantDisable(param).then(res => {
          if (res && res.result == 0) {
            record.sta = param.sta;
            this.$message.success(res.msg);
          }
        });
      } else if (type == "house") {
        let param = {};
        param.merchantNo = record.merchantNo;
        this.$router.push({
          name: "HouseList",
          query: { param: param }
        });
      } else if (type == "bind") {
        let param = {};
        param.userNo = record.userNo;
        param.merchantNo = this.currentMerchantNo;
        param.type = "bind";
        this.$http.roomBksApi.unBindMerchantUser(param).then(res => {
          if (res && res.result == 0) {
            this.bindModal.visible = false;
            this.$message.success(res.msg);
            this.$http.roomBksApi
              .listMerchantBindUserByMerchantNo({
                merchantNo: this.currentMerchantNo
              })
              .then(res => {
                if (res && res.result == 0) {
                  this.modal.bindList = res.resultObject;
                }
              });
          }
        });
      }
    },
    unbind(item) {
      let param = {};
      param.merchantNo = this.currentMerchantNo;
      param.userNo = item.userNo;
      param.type = "unbind";
      this.$http.roomBksApi.unBindMerchantUser(param).then(res => {
        if (res && res.result == 0) {
          this.modal.visible = false;
          this.currentMerchantNo = "";
          this.$message.success(res.msg);
          this.$refs.table.refresh(true);
        }
      });
    },
    showBindModal() {
      this.bindModal.visible = true;
    },
    searchUser() {
      if (!this.bindModal.queryParam.mobile) {
        this.$message.info("请输入手机号");
        return;
      }
      this.$refs.bindBable.refresh(true);
    },
    add() {
      this.$refs.districtInfo.showModal("add", null);
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    getBaseHelpCode() {
      this.$http.systemBksApi
        .findProvinceCityDistrictCircleHelpCode({
          isProvince: "T",
          isCity: "T"
        })
        .then(res => {
          this.provinceList = res.resultObject.provinceList;
          this.cityList = res.resultObject.cityList;
        });
    },
    handleProvinceChange(value) {
      let arr = [];
      for (let city of this.cityList) {
        if (city.provinceCode == value) {
          arr.push(city);
        }
      }
      this.tmpCityList = arr;
    }
  }
};
</script>
<style lang="less">
.box-cell {
  display: flex;
  justify-content: space-between;
  p {
    width: 20%;
  }
}

.box-column {
  display: flex;
  justify-content: space-between;
  p {
    width: 20%;
    font-weight: 600;
  }
}
.user-head {
  width: 40px;
  height: 40px;
  margin-right: 5px;
}
</style>
